import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import HotList from "@/pages/hot/page";
import ArticleDetail from "@/pages/article/page";
import Topics from "@/pages/topics/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "hot", element: <HotList /> },
      { path: "hot/:id", element: <ArticleDetail /> },
      { path: "topics", element: <Topics /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;